import './src/css/main.css';
import { wrapWithProviders } from './src/wrap-with-providers.tsx';

export const wrapRootElement = wrapWithProviders;
